query GetEmployeeKit($employeeId: ID!) {
  searchAssets(employeeId: $employeeId, limit: 100) {
    collection {
      id
      fphNumber
      productName
      status
      currentAssignment {
        id
        expectedReturnMethod
        returnDueOn
      }
    }
  }
}
